import SingleDateFilterEdit from '../editors/SingleDateFilterEdit';
import { SingleDateRangePresets } from './Constants';
import { RangedPresetValue } from './Types';
import { MultipleRangePresetProvider } from './MultipleRangePresetValue';
import moment from 'moment';

/**
 * Implementation of the a single date preset provider specific to dates
 */
export class SingleDateFilterProvider extends MultipleRangePresetProvider {
	public getPresets = () => SingleDateRangePresets;
	public isValidRangePresetValue = (value: RangedPresetValue) => {
		const fromValue = value.fromValue ? moment(value.fromValue) : null;
		const toValue = value.toValue ? moment(value.toValue) : null;

		const fromValueValid = fromValue === null || fromValue.isValid();
		const toValueValid = toValue === null || toValue.isValid();

		if (!fromValueValid || !toValueValid) {
			return false;
		}

		return true;
	};
	public getComponent = () => SingleDateFilterEdit;
}
